var _require = require('./src/scrape'),
    getUserData = _require.getUserData,
    getPostData = _require.getPostData;

module.exports = getUserData;
module.exports.getUserData = getUserData;
module.exports.getPostData = getPostData;